import AccountTableHeaderElement from './AccountTableHeader.jsx';

export default AccountTableHeaderElement;
